import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import {
  ADVERTISINGS_FETCH,
  ADVERTISING_FETCH,
  ADVERTISING_INSERT,
  ADVERTISING_UPDATE,
  ADVERTISINGS_ORDERBY,
  ADVERTISINGS_FILTER,
  ADVERTISINGS_PAGINATION,
} from "../constants";

const initialState = {
  advertising: null,
  advertisings: [],
  advertisingsCount: null,
  advertisingsOrderBy: "startDate",
  advertisingsFilter: null,
  advertisingsPagination: {
    defaultActivePage: 1,
    totalPages: 1,
    activePage: 1,
  },
};

const persistConfig = {
  key: "advertising",
  storage,
  blacklist: [
    "advertisingsPagination",
    "advertisingsFilter",
  ],
};

function advertisingReducer(state = initialState, action) {
  switch (action.type) {
    case ADVERTISINGS_FETCH:
      return {
        ...state,
        advertisings: action.result,
        advertisingsCount: action.count,
      };

    case ADVERTISING_FETCH:
      return { ...state, advertising: action.result };

    case ADVERTISING_INSERT:
      return {
        ...state,
        advertisings: [action.result, ...state.advertisings],
        advertisingsCount: (state.advertisingsCount || 0) + 1,
      };

    case ADVERTISING_UPDATE:
      return {
        ...state,
        advertisings: state.advertisings.map(ad =>
          ad.id === action.result.id ? action.result : ad
        ),
      };

    case ADVERTISINGS_ORDERBY:
      return { ...state, advertisingsOrderBy: action.value };

    case ADVERTISINGS_FILTER:
      return { ...state, advertisingsFilter: action.value };

    case ADVERTISINGS_PAGINATION:
      return { ...state, advertisingsPagination: action.value };

    default:
      return state;
  }
}

export default persistReducer(persistConfig, advertisingReducer);